<template>
  <!--股东信息-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :scroll="scroll"
    :bordered="bordered"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '股东',
          dataIndex: 'shareholderName',
          key: 'shareholderName',
        },
        {
          title: '股东类型',
          dataIndex: 'shareholderType',
          key: 'shareholderType',
        },
        {
          title: '认缴日期',
          dataIndex: 'subscribedTime',
          key: 'subscribedTime',
        },
        {
          title: '认缴出资（万元)',
          dataIndex: 'subscribedCapital',
          key: 'subscribedCapital',
          ellipsis: true,
        },
        {
          title: '占股比例',
          dataIndex: 'shareRatio',
          key: 'shareRatio',
        },
        {
          title: '实缴金额（万元）',
          dataIndex: 'actualPaymentAmount',
          key: 'actualPaymentAmount',
        },
        {
          title: '实缴出资时间',
          key: 'actualContributionTime',
        },
      ],
      loading: false,
      bordered: true,
      scroll: { x: 1300 }, //滚动设置
    }
  },
  methods: {},
}
</script>
